import * as Sentry from '@sentry/react';
import { config } from './config';

// Errors thrown by scripts that in-app browsers and extensions inject into the
// page, not by our bundle (e.g. GRAVEL-GAMES-WEB-3, Instagram's IAB on iOS).
const IGNORED_ERRORS: (string | RegExp)[] = [
  /window\._META/,
  /IABInnerFrame/,
  /window\.webkit\.messageHandlers/,
  /__gCrWeb/,
  /instantSearchSDKJSBridgeClearHighlight/,
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/,
];

const IGNORED_URLS: RegExp[] = [
  /^(chrome|moz|safari)(-web)?-extension:\/\//,
  /^webkit-masked-url:\/\//,
];

export function initSentry(): void {
  if (!config.sentryDsn) return;
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.sentryEnvironment,
    release: config.sentryRelease,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    sendDefaultPii: false,
    ignoreErrors: IGNORED_ERRORS,
    denyUrls: IGNORED_URLS,
  });
}
